export default __webpack_public_path__ + "images/963b0c23be4ce7d4de9db2b8b1a7d4d5-social_media.webp";